import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { CertificationService } from '../certification/certification.service';

@Injectable({
  providedIn: 'root'
})
export class FiltresService {

  constructor(
    private _certif: CertificationService
  ) { }

  public setHeaders(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'nom'
  }, ids?: string[], needle?:string|string[]): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.set('x-per-page', String(filtre.perpage));
    headers = headers.set('x-page', String(filtre.currentPage));
    headers = headers.set('x-sort', filtre.sortOrder || SortEnum.ASC);
    headers = headers.set('x-sort-attribut', filtre.sortBy || 'nom');
    if (filtre.find) {
      headers = headers.set('x-find', filtre.find);
    } else {
      headers = headers.delete('x-find');
    }
    if (ids && ids.length > 0) {
      headers = headers.set('x-ids', JSON.stringify(ids));
    }
    if(needle && needle.length>0){
      headers = headers.set('x-needle', needle);
    }
    return headers;
  }

  // public setBdgHeaders(headers: HttpHeaders, isBDG: boolean): HttpHeaders {
  //   /**
  //    * TODO
  //    * On pourrait imaginer que cette méthode soit appelée
  //    * par l'interceptor pour setter ce header.
  //    * Mais il faudrait que la valeur de isBDG soit stockée (service ? localstorage ?)
  //    */
  //   if (isBDG) {
  //     headers = headers.set('x-bdg-actif', 'true');
  //   } else {
  //     headers = headers.delete('x-bdg-actif');
  //   }
  //   return headers;
  // }
}
